"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSIServerClientInterface = void 0;
const axios_1 = __importDefault(require("axios"));
const APIErrors_1 = require("./resources/APIErrors");
const APIHTTPErrorCodes_1 = require("./resources/APIHTTPErrorCodes");
const APITasks_1 = require("./resources/APITasks");
const ConsolePromptCommands_1 = require("./resources/ConsolePromptCommands");
const TranslationLocales_1 = require("./resources/TranslationLocales");
const APIAbortController_1 = require("./APIAbortController");
const APIErrorSupplier_1 = require("./APIErrorSupplier");
const APITaskSupplier_1 = require("./APITaskSupplier");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const MimeTypes_1 = require("./MimeTypes");
const http = __importStar(require("http"));
const https = __importStar(require("https"));
const modeNode = FSIServerClientUtils_1.FSIServerClientUtils.GET_MODE_NODE();
class FSIServerClientInterface {
    constructor(client, logLevel) {
        this.client = client;
        this.logLevel = logLevel;
        this.sessionCookie = null;
        this.bLoggedIn = false;
        this.translations = {};
        this.mimeTypes = false;
        this.defaultHeaders = {};
        this.classInit = {
            client,
            com: this,
        };
        this.err = new APIErrorSupplier_1.APIErrorSupplier();
        this.taskSupplier = new APITaskSupplier_1.APITaskSupplier();
        this.currentTask = this.taskSupplier.get(APITasks_1.APITasks.idle);
        this.previousTask = this.taskSupplier.get(APITasks_1.APITasks.idle);
        if (modeNode) {
            const httpAgentOptions = {
                keepAlive: true
            };
            const httpAgent = new http.Agent(httpAgentOptions);
            const httpsAgent = new https.Agent(httpAgentOptions);
            this.iAxios = axios_1.default.create({
                httpAgent: httpAgent,
                httpsAgent: httpsAgent,
                baseURL: client.getHost() + "/"
            });
        }
        else {
            this.iAxios = axios_1.default.create({
                baseURL: client.getHost() + "/"
            });
        }
        this.defaultHeaders.Accept = "application/json";
        if (modeNode) {
            this.defaultHeaders['User-Agent'] = FSIServerClientUtils_1.FSIServerClientUtils.USERAGENT;
        }
        for (const key of Object.keys(this.defaultHeaders)) {
            this.iAxios.defaults.headers.common[key] = this.defaultHeaders[key];
        }
        this.iAxios.defaults.validateStatus = () => {
            return true;
        };
    }
    static GET_TRUE_PROMISE() {
        return new Promise((resolve) => {
            return resolve(true);
        });
    }
    static VALIDATE_TRANSLATION(translation) {
        let valid = true;
        let ret;
        const checks = [
            { theClass: APIErrors_1.APIErrors, sectionName: "errors" },
            { theClass: APITasks_1.APITasks, sectionName: "tasks" },
            { theClass: ConsolePromptCommands_1.ConsolePromptCommands, sectionName: "commands" },
            { theClass: TranslationLocales_1.TranslationLocales, sectionName: "locale" }
        ];
        for (const check of checks) {
            ret = FSIServerClientInterface.validateTranslationSection(translation, check.theClass, check.sectionName);
            if (!ret && valid) {
                valid = ret;
            }
        }
        return valid;
    }
    static getLogPrefix(level) {
        const strLevel = "[" + FSIServerClientInterface.logLevelLabels[level] + "] ";
        const d = new Date();
        return "[" + d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " "
            + d.toTimeString().substring(0, 8) + "."
            + ("00" + d.getUTCMilliseconds()).slice(-3) + "] " + strLevel;
    }
    static validateTranslationSection(translation, theClass, sectionName) {
        let valid = true;
        const section = translation[sectionName];
        const keys = {};
        if (!section) {
            valid = false;
            console.log("section \"" + sectionName + "\" missing");
        }
        else {
            Object.keys(theClass).forEach((key) => {
                keys[key] = true;
                if (!section[key]) {
                    console.log("\"" + key + "\" missing in translation." + sectionName);
                    valid = false;
                }
                else if (theClass[key].key && theClass[key].key !== key) {
                    console.log("\"" + key + "\" != \"" + theClass[key].key + "\" - error in class for " + sectionName);
                    valid = false;
                }
            });
            Object.keys(section).forEach((key) => {
                if (!keys[key] && key !== "templateContent") {
                    console.log("\"" + key + "\" in translation." + sectionName + " not needed");
                    valid = false;
                }
            });
        }
        return valid;
    }
    setSessionCookie(sessionCookie) {
        this.sessionCookie = sessionCookie;
        if (modeNode) {
            this.defaultHeaders.Cookie = this.iAxios.defaults.headers.common.Cookie = sessionCookie;
        }
    }
    isAbortError(err) {
        if (axios_1.default.isCancel(err)) {
            err.type = "aborted";
        }
        return (err.type === "aborted");
    }
    getAbortPromise() {
        return new Promise((resolve, reject) => {
            return reject(this.err.get(APIErrors_1.APIErrors.userAborted));
        });
    }
    getNewAbortController() {
        return new APIAbortController_1.APIAbortController(this.err.get(APIErrors_1.APIErrors.userAborted));
    }
    lookupMimeType(fileName) {
        if (!this.mimeTypes) {
            this.mimeTypes = new MimeTypes_1.MimeTypes();
        }
        return this.mimeTypes.lookup(fileName);
    }
    lookupMimeExtension(mimeType) {
        if (!this.mimeTypes) {
            this.mimeTypes = new MimeTypes_1.MimeTypes();
        }
        return this.mimeTypes.extension(mimeType);
    }
    getLogLevel() {
        return this.logLevel;
    }
    setLogLevel(level) {
        this.logLevel = level;
    }
    getAxiosRequestConfig(options = null, headers) {
        if (headers) {
            for (const key of Object.keys(this.defaultHeaders)) {
                if (headers[key] === undefined) {
                    headers[key] = this.defaultHeaders[key];
                }
                else if (headers[key] === null) {
                    delete headers[key];
                }
            }
        }
        const ret = {
            headers,
            timeout: 0,
            withCredentials: true,
        };
        if (options !== null && options.abortController) {
            ret.signal = options.abortController.renew();
        }
        return ret;
    }
    onLoginChange(loggedIn) {
        this.bLoggedIn = loggedIn;
    }
    doLogLine(line) {
        if (modeNode) {
            process.stdout.write(line + "\n");
        }
        else {
            console.log(line);
        }
    }
    log(level, message) {
        if (level >= this.logLevel) {
            this.doLogLine(FSIServerClientInterface.getLogPrefix(level) + message);
        }
    }
    setTranslations(translations) {
        this.translations = translations;
        this.err.setTranslations(translations);
        this.taskSupplier.setTranslations(translations);
    }
    getTranslations() {
        return this.translations;
    }
    translateCommands(pOpts) {
        pOpts.buttonLabels = new Array(pOpts.buttons.length);
        const trans = this.translations.commands || {};
        for (let i = 0; i < pOpts.buttons.length; i++) {
            const cmd = pOpts.buttons[i];
            let translated = trans[cmd];
            if (!translated) {
                translated = cmd;
            }
            pOpts.validAnswers[translated.toLowerCase()] = cmd;
            pOpts.validReplies[cmd] = translated;
            pOpts.buttonLabels[i] = translated;
        }
    }
    async prompt(options, apiTask, errKeys, buttons, taskController) {
        const promptReply = {
            apiTask,
            errKeys,
            reply: "",
            replyAll: undefined,
            time: FSIServerClientUtils_1.FSIServerClientUtils.NOW()
        };
        let reply = "";
        if (options.fnPrompt) {
            const promptOpts = {
                buttonLabels: [],
                buttons,
                validAnswers: {},
                validReplies: {}
            };
            this.translateCommands(promptOpts);
            while (promptOpts.validReplies[reply] === undefined) {
                reply = await options.fnPrompt.fn.call(options.fnPrompt.ctx, apiTask.getMessage(), promptOpts);
            }
            promptReply.reply = reply;
        }
        else {
            promptReply.reply = buttons[0];
        }
        if (taskController) {
            taskController.evaluateDecision(promptReply);
        }
        promptReply.time = FSIServerClientUtils_1.FSIServerClientUtils.NOW() - promptReply.time;
        return promptReply;
    }
    async getOverwriteReply(options, targetPath, taskController) {
        const tsk = this.taskSupplier.get(APITasks_1.APITasks.overwriteTargetFile, [targetPath]);
        const keys = tsk.getKeys();
        if (taskController && taskController.getUserDecision(keys)) {
            return taskController.getUserDecision(keys);
        }
        return await this.prompt(options, tsk, keys, [
            "cancel",
            "overwrite",
            "overwriteAll",
            "skip",
            "skipAll"
        ], taskController);
    }
    getResponse(url, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosResponsePromise(this.iAxios.get(url, config), mainErrorData, httpOptions);
    }
    getJSON(url, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosJSONPromise(this.iAxios.get(url, config), mainErrorData, httpOptions);
    }
    postJSON(url, data, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosJSONPromise(this.iAxios.post(url, data, config), mainErrorData, httpOptions);
    }
    postResponse(url, data, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosResponsePromise(this.iAxios.post(url, data, config), mainErrorData, httpOptions);
    }
    postJSONBoolean(url, data, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosBooleanPromise(this.iAxios.post(url, data, config), mainErrorData, httpOptions);
    }
    putJsonBoolean(url, data, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosBooleanPromise(this.iAxios.put(url, data, config), mainErrorData, httpOptions);
    }
    deleteJsonBoolean(url, mainErrorData, config, httpOptions) {
        if (!config) {
            config = this.getAxiosRequestConfig(httpOptions);
        }
        return this.runAxiosBooleanPromise(this.iAxios.delete(url, config), mainErrorData, httpOptions);
    }
    runAxiosBooleanPromise(p, mainErrorData, httpOptions = {}) {
        return this.runAxiosResponsePromise(p, mainErrorData, httpOptions)
            .then((response) => {
            return (response.status < 400);
        });
    }
    runAxiosResponsePromise(p, mainError, httpOptions) {
        return p
            .then(async (response) => {
            if (httpOptions && httpOptions.abortController)
                httpOptions.abortController.release();
            if (response.data && response.data.statuscode) {
                response.status = response.data.statuscode;
            }
            if (response.status > 399) {
                if (httpOptions && httpOptions.ignoreErrors && httpOptions.ignoreErrors[response.status]) {
                    if (httpOptions.handleIgnoredError) {
                        await httpOptions.handleIgnoredError(response.status);
                    }
                    response.status = 200;
                }
                else {
                    if (mainError && mainError.def) {
                        throw this.err.get(mainError.def, mainError.content, APIErrors_1.APIErrors.httpError, [APIHTTPErrorCodes_1.APIHTTPErrorCodes.GET_CODE(response.status), response.config.url]);
                    }
                    else {
                        throw this.err.get(APIErrors_1.APIErrors.httpError, [APIHTTPErrorCodes_1.APIHTTPErrorCodes.GET_CODE(response.status), response.config.url]);
                    }
                }
            }
            return response;
        })
            .catch(error => {
            if (httpOptions && httpOptions.abortController)
                httpOptions.abortController.release();
            throw error;
        });
    }
    runAxiosJSONPromise(p, mainError, options) {
        return this.runAxiosResponsePromise(p, mainError, options)
            .then(response => {
            return response.data;
        });
    }
}
exports.FSIServerClientInterface = FSIServerClientInterface;
FSIServerClientInterface.logLevelLabels = {
    0: "trace",
    1: "debug",
    2: "info",
    3: "warn",
    4: "error",
    5: "fatal"
};
